export default __webpack_public_path__ + "static/media/green-check.b715e0ba.svg";